import {
  Box,
  Collapse,
  Alert,
  AlertTitle,
  Typography,
  Button,
} from "@mui/material";

// Edit Lock Alert Component
interface EditLockAlertProps {
  show: boolean;
}

export default ({ show }: EditLockAlertProps) => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Collapse
      in={show}
      sx={{
        position: "absolute",
        bottom: "50px",
        zIndex: 1000,
        width: "100%",
      }}
    >
      <Alert
        severity="warning"
        sx={{
          width: "100%",
          marginTop: "16px",
          marginBottom: "16px",
          borderRadius: "8px",
          "& .MuiAlert-message": {
            width: "100%",
          },
          "& .MuiAlert-action": {
            alignItems: "flex-start",
            paddingTop: "4px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <AlertTitle>
              This document is being edited by someone else
            </AlertTitle>
            <Typography variant="body2">
              Any new changes you make may be lost. Refresh to see the latest
              version.
            </Typography>
          </Box>
          <Button
            variant="contained"
            size="small"
            onClick={handleRefresh}
            sx={{
              alignSelf: "flex-start",
            }}
          >
            Refresh
          </Button>
        </Box>
      </Alert>
    </Collapse>
  );
};
